module.exports = __webpack_public_path__ + "img/winners-list_inzh.6cffffe6.png";